// Содержание таблиц для 7 класса (по фотографиям буклета «Отечественная музыка ХХ века»).

const TABLE_CONTENT_7_DISK1 = [
    {
        num: 1,
        authorTitle: 'С. И. Танеев. Симфония до минор',
        performer: 'Государственный академический симфонический оркестр СССР. Дир. Е. Светланов',
        tracks: [
            { trackNum: 3, duration: '0:51' }, { trackNum: 4, duration: '3:21' }, { trackNum: 5, duration: '1:35' },
            { trackNum: 6, duration: '3:10' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'I часть. Вступление', trackNum: 3, duration: '0:51', indentLevel: 1 },
            { type: 'track', section: 'II часть. Фрагмент', trackNum: 4, duration: '3:21', indentLevel: 1 },
            { type: 'track', section: 'III часть. Фрагмент', trackNum: 5, duration: '1:35', indentLevel: 1 },
            { type: 'track', section: 'IV часть. Кода', trackNum: 6, duration: '3:10', indentLevel: 1 },
        ],
    },
    { num: 2, authorTitle: 'А. К. Лядов. Музыкальная табакерка', performer: '— // —', tracks: [{ trackNum: 8, duration: '2:24' }], rows: [{ type: 'track', section: 'Музыкальная табакерка', trackNum: 8, duration: '2:24', indentLevel: 0 }] },
    { num: 3, authorTitle: 'А. К. Лядов. Баллада «Про старину»', performer: '— // —', tracks: [{ trackNum: 10, duration: '5:32' }], rows: [{ type: 'track', section: 'Баллада «Про старину»', trackNum: 10, duration: '5:32', indentLevel: 0 }] },
    { num: 4, authorTitle: 'А. К. Лядов. «Волшебное озеро»', performer: '— // —', tracks: [{ trackNum: 12, duration: '7:12' }], rows: [{ type: 'track', section: '«Волшебное озеро»', trackNum: 12, duration: '7:12', indentLevel: 0 }] },
    {
        num: 5,
        authorTitle: 'А. К. Глазунов. Симфония №5',
        performer: '— // —',
        tracks: [{ trackNum: 14, duration: '2:36' }, { trackNum: 15, duration: '1:29' }, { trackNum: 16, duration: '1:37' }],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'I часть. Экспозиция:', indentLevel: 1 },
            { type: 'track', section: 'Главная партия', trackNum: 14, duration: '2:36', indentLevel: 2 },
            { type: 'track', section: 'Побочная партия', trackNum: 15, duration: '1:29', indentLevel: 2 },
            { type: 'track', section: 'Заключительная партия', trackNum: 16, duration: '1:37', indentLevel: 2 },
        ],
    },
    {
        num: 6,
        authorTitle: 'А. К. Глазунов. Концерт для скрипки с оркестром ми минор',
        performer: 'Большой симфонический оркестр гостелерадио СССР. Дир. В. Федосеев. В. Третьяков (скрипка)',
        tracks: [
            { trackNum: 18, duration: '1:57' }, { trackNum: 19, duration: '2:31' }, { trackNum: 20, duration: '3:38' },
            { trackNum: 21, duration: '3:44' }, { trackNum: 22, duration: '2:53' }, { trackNum: 23, duration: '5:21' },
        ],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'I часть:', indentLevel: 1 },
            { type: 'track', section: 'Главная партия', trackNum: 18, duration: '1:57', indentLevel: 2 },
            { type: 'track', section: 'Побочная партия', trackNum: 19, duration: '2:31', indentLevel: 2 },
            { type: 'track', section: 'Эпизод', trackNum: 20, duration: '3:38', indentLevel: 2 },
            { type: 'track', section: 'Разработка', trackNum: 21, duration: '3:44', indentLevel: 2 },
            { type: 'track', section: 'Каденция', trackNum: 22, duration: '2:53', indentLevel: 2 },
            { type: 'track', section: 'II часть', trackNum: 23, duration: '5:21', indentLevel: 1 },
        ],
    },
    {
        num: 7,
        authorTitle: 'А. Н. Скрябин. Симфония №3. «Божественная поэма»',
        performer: 'Ленинградский симф. орк. Дир. В. Гергиев',
        tracks: [
            { trackNum: 25, duration: '1:07' }, { trackNum: 26, duration: '1:49' }, { trackNum: 27, duration: '0:35' },
            { trackNum: 28, duration: '1:19' }, { trackNum: 29, duration: '1:53' },
        ],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'І часть. «Борьба»', indentLevel: 1 },
            { type: 'subheading', section: 'Экспозиция:', indentLevel: 2 },
            { type: 'track', section: 'Вступление', trackNum: 25, duration: '1:07', indentLevel: 3 },
            { type: 'track', section: 'Главная партия', trackNum: 26, duration: '1:49', indentLevel: 3 },
            { type: 'track', section: 'Первая побочная партия', trackNum: 27, duration: '0:35', indentLevel: 3 },
            { type: 'track', section: 'Вторая побочная партия', trackNum: 28, duration: '1:19', indentLevel: 3 },
            { type: 'track', section: 'Заключительная партия', trackNum: 29, duration: '1:53', indentLevel: 3 },
        ],
    },
    { num: 8, authorTitle: 'А. Н. Скрябин. Прелюдия ми минор. Ор. 11', performer: 'В. Кастельский (фортепиано)', tracks: [{ trackNum: 31, duration: '2:33' }], rows: [{ type: 'track', section: 'Прелюдия ми минор. Ор. 11', trackNum: 31, duration: '2:33', indentLevel: 0 }] },
    { num: 9, authorTitle: 'А. Н. Скрябин. Прелюдия ля минор. Ор. 11', performer: 'В. Кастельский (фортепиано)', tracks: [{ trackNum: 33, duration: '1:53' }], rows: [{ type: 'track', section: 'Прелюдия ля минор. Ор. 11', trackNum: 33, duration: '1:53', indentLevel: 0 }] },
    { num: 10, authorTitle: 'А.Н. Скрябин. Этюд ре-диез минор. Ор. 8', performer: 'В. Мержанов (фортепиано)', tracks: [{ trackNum: 35, duration: '2:29' }], rows: [{ type: 'track', section: 'Этюд ре-диез минор. Ор. 8', trackNum: 35, duration: '2:29', indentLevel: 0 }] },
];

const TABLE_CONTENT_7_DISK2 = [
    { num: 11, authorTitle: 'С. В. Рахманинов. Прелюдия до-диез минор', performer: 'В. Диев (фортепиано)', tracks: [{ trackNum: 2, duration: '4:25' }], rows: [{ type: 'track', section: 'Прелюдия до-диез минор', trackNum: 2, duration: '4:25', indentLevel: 0 }] },
    {
        num: 12,
        authorTitle: 'С. В. Рахманинов. Концерт №3 для фортепиано с оркестром',
        performer: 'Симфонический оркестр телевидения и радио СССР. Дир. Н. Аносов. В. Мержанов (фортепиано)',
        tracks: [{ trackNum: 4, duration: '1:32' }],
        rows: [{ type: 'title' }, { type: 'track', section: 'I часть, главная партия', trackNum: 4, duration: '1:32', indentLevel: 1 }],
    },
    {
        num: 13,
        authorTitle: 'С. В. Рахманинов. Симфония №3',
        performer: 'Московский симфонический оркестр. Дир. И. Головшин',
        tracks: [{ trackNum: 6, duration: '0:53' }, { trackNum: 7, duration: '1:25' }, { trackNum: 8, duration: '2:10' }],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'I часть:', indentLevel: 1 },
            { type: 'track', section: 'Вступление', trackNum: 6, duration: '0:53', indentLevel: 2 },
            { type: 'subheading', section: 'Экспозиция:', indentLevel: 2 },
            { type: 'track', section: 'Главная партия', trackNum: 7, duration: '1:25', indentLevel: 3 },
            { type: 'track', section: 'Побочная партия', trackNum: 8, duration: '2:10', indentLevel: 3 },
        ],
    },
    {
        num: 14,
        authorTitle: 'С. В. Рахманинов. Музыкальный момент ми минор, ор. 16',
        performer: 'И. Осипова (фортепиано)',
        tracks: [{ trackNum: 10, duration: '3:02' }],
        rows: [{ type: 'track', section: 'Музыкальный момент ми минор, ор. 16', trackNum: 10, duration: '3:02', indentLevel: 0 }],
    },
    { num: 15, authorTitle: 'С. В. Рахманинов. Прелюдия Ре мажор. Ор. 23', performer: 'В. Диев (фортепиано)', tracks: [{ trackNum: 12, duration: '5:38' }], rows: [{ type: 'track', section: 'Прелюдия Ре мажор. Ор. 23', trackNum: 12, duration: '5:38', indentLevel: 0 }] },
    { num: 16, authorTitle: 'С. В. Рахманинов. Этюд-картина ля минор. Ор. 39', performer: 'Г. Шелли (фортепиано)', tracks: [{ trackNum: 14, duration: '2:44' }], rows: [{ type: 'track', section: 'Этюд-картина ля минор. Ор. 39', trackNum: 14, duration: '2:44', indentLevel: 0 }] },
    {
        num: 17,
        authorTitle: 'С. В. Рахманинов. Концерт №2 для фортепиано с оркестром, до минор',
        performer: 'Орк. С.-Петербургской филармонии. Дир. А. Аниханов. А. Святкин (фортепиано)',
        tracks: [
            { trackNum: 16, duration: '0:28' }, { trackNum: 17, duration: '1:53' }, { trackNum: 18, duration: '1:18' },
            { trackNum: 19, duration: '1:09' }, { trackNum: 20, duration: '1:36' }, { trackNum: 21, duration: '4:18' },
            { trackNum: 23, duration: '11:32' },
            { trackNum: 25, duration: '0:52' }, { trackNum: 26, duration: '1:16' }, { trackNum: 27, duration: '1:35' },
            { trackNum: 28, duration: '0:51' }, { trackNum: 29, duration: '2:16' }, { trackNum: 30, duration: '4:44' },
            { trackNum: 31, duration: '1:22' },
        ],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'I часть:', indentLevel: 1 },
            { type: 'track', section: 'Вступление', trackNum: 16, duration: '0:28', indentLevel: 2 },
            { type: 'track', section: 'Главная партия', trackNum: 17, duration: '1:53', indentLevel: 2 },
            { type: 'track', section: 'Побочная партия', trackNum: 18, duration: '1:18', indentLevel: 2 },
            { type: 'track', section: 'Заключительная партия', trackNum: 19, duration: '1:09', indentLevel: 2 },
            { type: 'track', section: 'Разработка', trackNum: 20, duration: '1:36', indentLevel: 2 },
            { type: 'track', section: 'Реприза', trackNum: 21, duration: '4:18', indentLevel: 2 },
            { type: 'track', section: 'II часть Adagio sostenuto ми мажор', trackNum: 23, duration: '11:32', indentLevel: 1 },
            { type: 'subheading', section: 'ІІІ часть Финал. Allegro scherzando:', indentLevel: 1 },
            { type: 'track', section: 'Вступление', trackNum: 25, duration: '0:52', indentLevel: 2 },
            { type: 'track', section: 'Главная партия', trackNum: 26, duration: '1:16', indentLevel: 2 },
            { type: 'track', section: 'Побочная партия', trackNum: 27, duration: '1:35', indentLevel: 2 },
            { type: 'track', section: 'Заключительная партия', trackNum: 28, duration: '0:51', indentLevel: 2 },
            { type: 'track', section: 'Разработка', trackNum: 29, duration: '2:16', indentLevel: 2 },
            { type: 'track', section: 'Реприза', trackNum: 30, duration: '4:44', indentLevel: 2 },
            { type: 'track', section: 'Кода', trackNum: 31, duration: '1:22', indentLevel: 2 },
        ],
    },
    { num: 18, authorTitle: 'С. В. Рахманинов. Романс «Не пой, красавица, при мне». Ст. А. Пушкина', performer: 'Д. Хворостовский', tracks: [{ trackNum: 33, duration: '4:25' }], rows: [{ type: 'track', section: 'Романс «Не пой, красавица, при мне»', trackNum: 33, duration: '4:25', indentLevel: 0 }] },
    { num: 19, authorTitle: 'С. В. Рахманинов. Романс «Весенние воды». Ст. Ф. Тютчева', performer: 'Ю. Гуляев', tracks: [{ trackNum: 35, duration: '2:01' }], rows: [{ type: 'track', section: 'Романс «Весенние воды»', trackNum: 35, duration: '2:01', indentLevel: 0 }] },
    { num: 20, authorTitle: 'С. В. Рахманинов. Вокализ', performer: 'М. Леонтьева', tracks: [{ trackNum: 37, duration: '3:45' }], rows: [{ type: 'track', section: 'Вокализ', trackNum: 37, duration: '3:45', indentLevel: 0 }] },
];

const TABLE_CONTENT_7_DISK3 = [
    {
        num: 21,
        authorTitle: 'И. Ф. Стравинский. Балет «Петрушка»',
        performer: 'Оркестр Славянской филармонии. Дир. Г. П. Гмюр',
        tracks: [
            { trackNum: 2, duration: '9:57' }, { trackNum: 4, duration: '4:24' }, { trackNum: 6, duration: '6:45' },
            { trackNum: 8, duration: '13:08' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: '1 картина «Народные гулянья на масляной»', trackNum: 2, duration: '9:57', indentLevel: 1 },
            { type: 'track', section: '2 картина. «У Петрушки»', trackNum: 4, duration: '4:24', indentLevel: 1 },
            { type: 'track', section: '3 картина. «У арапа»', trackNum: 6, duration: '6:45', indentLevel: 1 },
            { type: 'track', section: '4 картина. «Народные гулянья на масляной»', trackNum: 8, duration: '13:08', indentLevel: 1 },
        ],
    },
    { num: 22, authorTitle: 'И. О. Дунаевский. «Марш веселых ребят». Сл. В. Лебедева-Кумача', performer: 'Большой хор ВР, вокальный квартет «Гая», детский хор', tracks: [{ trackNum: 9, duration: '3:00' }], rows: [{ type: 'track', section: '«Марш веселых ребят»', trackNum: 9, duration: '3:00', indentLevel: 0 }] },
    { num: 23, authorTitle: 'И. О. Дунаевский. «Песня о Родине» из кинофильма «Цирк». Сл. В. Лебедева-Кумача', performer: 'М. Эйзен', tracks: [{ trackNum: 10, duration: '5:05' }], rows: [{ type: 'track', section: '«Песня о Родине»', trackNum: 10, duration: '5:05', indentLevel: 0 }] },
    { num: 24, authorTitle: '«Священная война». Музыка А. Александрова, сл. В. Лебедева-Кумача', performer: 'Ансамбль им. А. В. Александрова', tracks: [{ trackNum: 11, duration: '4:05' }], rows: [{ type: 'track', section: '«Священная война»', trackNum: 11, duration: '4:05', indentLevel: 0 }] },
    {
        num: 25,
        authorTitle: 'С. С. Прокофьев. Концерт №1 для фортепиано с оркестром, Ре-бемоль мажор',
        performer: 'Лондонский симфонический оркестр. Дир. А. Превин. В. Ашкенази (фортепиано)',
        tracks: [
            { trackNum: 13, duration: '1:14' }, { trackNum: 14, duration: '0:56' }, { trackNum: 15, duration: '1:21' },
            { trackNum: 16, duration: '4:34' }, { trackNum: 17, duration: '4:06' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Вступление', trackNum: 13, duration: '1:14', indentLevel: 1 },
            { type: 'track', section: 'Каденция', trackNum: 14, duration: '0:56', indentLevel: 1 },
            { type: 'track', section: 'Главная партия', trackNum: 15, duration: '1:21', indentLevel: 1 },
            { type: 'track', section: 'Побочная партия', trackNum: 16, duration: '4:34', indentLevel: 1 },
            { type: 'track', section: 'Реприза', trackNum: 17, duration: '4:06', indentLevel: 1 },
        ],
    },
    { num: 26, authorTitle: 'С. С. Прокофьев. Токката ре минор. Ор. 11', performer: 'В. Горовиц (фортепиано)', tracks: [{ trackNum: 19, duration: '3:42' }], rows: [{ type: 'track', section: 'Токката ре минор. Ор. 11', trackNum: 19, duration: '3:42', indentLevel: 0 }] },
    { num: 27, authorTitle: 'С. С. Прокофьев. 10 пьес для фортепиано. Ор. 12: Гавот соль минор', performer: 'Л. Тимофеева (фортепиано)', tracks: [{ trackNum: 21, duration: '2:38' }], rows: [{ type: 'track', section: 'Гавот соль минор', trackNum: 21, duration: '2:38', indentLevel: 0 }] },
];

const TABLE_CONTENT_7_DISK4 = [
    {
        num: 27,
        authorTitle: 'С. С. Прокофьев. 10 пьес для фортепиано. Ор. 12 (продолжение):',
        performer: 'Л. Тимофеева (фортепиано)',
        tracks: [{ trackNum: 2, duration: '2:03' }, { trackNum: 4, duration: '2:18' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Прелюд До мажор', trackNum: 2, duration: '2:03', indentLevel: 1 },
            { type: 'track', section: 'Юмористическое скерцо', trackNum: 4, duration: '2:18', indentLevel: 1 },
        ],
    },
    {
        num: 28,
        authorTitle: 'С. С. Прокофьев. Александр Невский:',
        performer: 'Республиканская хоровая капелла. Худ. рук. А. Юрлов. Гос. симф. орк. СССР. Дир. Е. Светланов. Л. Авдеева (меццо-сопрано)',
        tracks: [
            { trackNum: 6, duration: '1:16' }, { trackNum: 7, duration: '0:54' }, { trackNum: 8, duration: '1:02' },
            { trackNum: 10, duration: '3:42' }, { trackNum: 12, duration: '0:56' }, { trackNum: 13, duration: '1:30' },
            { trackNum: 15, duration: '1:45' }, { trackNum: 16, duration: '2:48' }, { trackNum: 17, duration: '3:04' },
            { trackNum: 18, duration: '0:37' }, { trackNum: 19, duration: '1:26' }, { trackNum: 20, duration: '1:57' },
            { trackNum: 21, duration: '1:03' }, { trackNum: 23, duration: '5:53' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'ІІ часть: «Песнь об Александре Невском». Первая часть «А и было дело»', trackNum: 6, duration: '1:16', indentLevel: 1 },
            { type: 'track', section: 'Средний раздел «Ух, как бились»', trackNum: 7, duration: '0:54', indentLevel: 1 },
            { type: 'track', section: 'Заключительный раздел (Реприза)', trackNum: 8, duration: '1:02', indentLevel: 1 },
            { type: 'track', section: 'ІІІ часть. «Крестоносцы во Пскове». Фрагмент', trackNum: 10, duration: '3:42', indentLevel: 1 },
            { type: 'track', section: 'IV часть: Вставайте, люди русские. 1 раздел', trackNum: 12, duration: '0:56', indentLevel: 1 },
            { type: 'track', section: 'На Руси родной', trackNum: 13, duration: '1:30', indentLevel: 1 },
            { type: 'track', section: 'У часть: «Ледовое побоище». Начальный эпизод', trackNum: 15, duration: '1:45', indentLevel: 1 },
            { type: 'track', section: 'Эпизод «скачки»', trackNum: 16, duration: '2:48', indentLevel: 1 },
            { type: 'track', section: 'Живым бойцам', trackNum: 17, duration: '3:04', indentLevel: 1 },
            { type: 'track', section: 'Эпизод русской атаки', trackNum: 18, duration: '0:37', indentLevel: 1 },
            { type: 'track', section: 'Кульминация (контрапункт)', trackNum: 19, duration: '1:26', indentLevel: 1 },
            { type: 'track', section: 'Эпизод гибели крестоносцев', trackNum: 20, duration: '1:57', indentLevel: 1 },
            { type: 'track', section: 'На Руси родной', trackNum: 21, duration: '1:03', indentLevel: 1 },
            { type: 'track', section: 'VI часть: «Мертвое поле»', trackNum: 23, duration: '5:53', indentLevel: 1 },
        ],
    },
    {
        num: 29,
        authorTitle: 'С. С. Прокофьев. Балет «Ромео и Джульетта»:',
        performer: 'Венский филарм. орк. Дир. В. Гергиев',
        tracks: [
            { trackNum: 25, duration: '2:22' }, { trackNum: 27, duration: '3:18' }, { trackNum: 29, duration: '2:50' },
            { trackNum: 31, duration: '5:27' }, { trackNum: 33, duration: '3:44' }, { trackNum: 35, duration: '3:20' },
            { trackNum: 37, duration: '5:57' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Сцена №3. Улица просыпается', trackNum: 25, duration: '2:22', indentLevel: 1 },
            { type: 'track', section: 'Сцена №10. Джульетта-девочка', trackNum: 27, duration: '3:18', indentLevel: 1 },
            { type: 'track', section: 'Сцена №12. Маски', trackNum: 29, duration: '2:50', indentLevel: 1 },
            { type: 'track', section: 'Сцена №13. Танец рыцарей', trackNum: 31, duration: '5:27', indentLevel: 1 },
            { type: 'track', section: 'Сцена №16. Мадригал', trackNum: 33, duration: '3:44', indentLevel: 1 },
            { type: 'track', section: 'Сцена №28. Венчание. Патер Лоренцо', trackNum: 35, duration: '3:20', indentLevel: 1 },
            { type: 'track', section: 'Сцена №39. Прощание перед разлукой', trackNum: 37, duration: '5:57', indentLevel: 1 },
        ],
    },
];

const TABLE_CONTENT_7_DISK5 = [
    {
        num: 30,
        authorTitle: 'С. С. Прокофьев. Балет «Золушка»',
        performer: 'БСО РТ СССР. Дир. Г. Рождественский',
        tracks: [
            { trackNum: 2, duration: '2:25' }, { trackNum: 4, duration: '3:00' }, { trackNum: 6, duration: '3:08' },
            { trackNum: 8, duration: '3:26' }, { trackNum: 10, duration: '1:55' }, { trackNum: 12, duration: '1:40' },
            { trackNum: 14, duration: '4:58' }, { trackNum: 16, duration: '2:06' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Вступление', trackNum: 2, duration: '2:25', indentLevel: 1 },
            { type: 'track', section: 'Сцена №3. Золушка', trackNum: 4, duration: '3:00', indentLevel: 1 },
            { type: 'track', section: '3 действие. Сцена №50. Аморозо', trackNum: 6, duration: '3:08', indentLevel: 1 },
            { type: 'track', section: 'Сцена №2. Па-де шаль', trackNum: 8, duration: '3:26', indentLevel: 1 },
            { type: 'track', section: 'Сцена №39. Принц и сапожники', trackNum: 10, duration: '1:55', indentLevel: 1 },
            { type: 'track', section: 'Сцена №40. Первый галоп Принца', trackNum: 12, duration: '1:40', indentLevel: 1 },
            { type: 'track', section: 'Сцена №36. Адажио. Дуэт Принца и Золушки.', trackNum: 14, duration: '4:58', indentLevel: 1 },
            { type: 'track', section: 'Сцена №14. Отъезд Золушки на бал. Вальс соль минор', trackNum: 16, duration: '2:06', indentLevel: 1 },
        ],
    },
    {
        num: 31,
        authorTitle: 'С. С. Прокофьев. Симфония №7 до-диез минор',
        performer: 'Берлинский филармонический оркестр. Дир. С. Озава',
        tracks: [
            { trackNum: 18, duration: '2:02' }, { trackNum: 19, duration: '1:06' }, { trackNum: 20, duration: '0:44' },
            { trackNum: 21, duration: '2:25' }, { trackNum: 22, duration: '3:07' }, { trackNum: 23, duration: '0:27' },
            { trackNum: 25, duration: '0:54' }, { trackNum: 26, duration: '1:26' }, { trackNum: 27, duration: '5:40' },
            { trackNum: 29, duration: '2:23' }, { trackNum: 30, duration: '3:28' },
            { trackNum: 32, duration: '0:20' }, { trackNum: 33, duration: '2:17' }, { trackNum: 34, duration: '3:00' }, { trackNum: 35, duration: '3:22' },
        ],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'І часть:', indentLevel: 1 },
            { type: 'track', section: 'Главная партия', trackNum: 18, duration: '2:02', indentLevel: 2 },
            { type: 'track', section: 'Побочная партия', trackNum: 19, duration: '1:06', indentLevel: 2 },
            { type: 'track', section: 'Заключительная партия', trackNum: 20, duration: '0:44', indentLevel: 2 },
            { type: 'track', section: 'Разработка', trackNum: 21, duration: '2:25', indentLevel: 2 },
            { type: 'track', section: 'Реприза', trackNum: 22, duration: '3:07', indentLevel: 2 },
            { type: 'track', section: 'Кода', trackNum: 23, duration: '0:27', indentLevel: 2 },
            { type: 'subheading', section: 'ІІ часть (Вальс):', indentLevel: 1 },
            { type: 'track', section: '1 тема', trackNum: 25, duration: '0:54', indentLevel: 2 },
            { type: 'track', section: '2 тема', trackNum: 26, duration: '1:26', indentLevel: 2 },
            { type: 'track', section: 'Средний раздел и реприза', trackNum: 27, duration: '5:40', indentLevel: 2 },
            { type: 'subheading', section: 'ІІІ часть. Анданте си бемоль мажор:', indentLevel: 1 },
            { type: 'track', section: '1 тема', trackNum: 29, duration: '2:23', indentLevel: 2 },
            { type: 'track', section: 'Средний раздел', trackNum: 30, duration: '3:28', indentLevel: 2 },
            { type: 'subheading', section: 'IV часть. Финал:', indentLevel: 1 },
            { type: 'track', section: 'Вступление', trackNum: 32, duration: '0:20', indentLevel: 2 },
            { type: 'track', section: 'Рефрен', trackNum: 33, duration: '2:17', indentLevel: 2 },
            { type: 'track', section: 'Эпизод в характере марша', trackNum: 34, duration: '3:00', indentLevel: 2 },
            { type: 'track', section: 'Кода', trackNum: 35, duration: '3:22', indentLevel: 2 },
        ],
    },
    {
        num: 32,
        authorTitle: 'Д. Д. Шостакович. Симфония №5',
        performer: 'Ленинградский филармонический оркестр. Дир. Е. Мравинский',
        tracks: [{ trackNum: 37, duration: '10:17' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: '1 часть. Тема-эпиграф, экспозиция, фрагмент разработки, включая кульминацию', trackNum: 37, duration: '10:17', indentLevel: 1 },
        ],
    },
];

const TABLE_CONTENT_7_DISK6 = [
    {
        num: 33,
        authorTitle: 'Д. Д. Шостакович. Симфония № 7, до минор',
        performer: 'Симфонический оркестр С.-Петербурга. Дир. В. Норетс',
        tracks: [
            { trackNum: 2, duration: '2:17' }, { trackNum: 3, duration: '2:59' }, { trackNum: 4, duration: '1:48' },
            { trackNum: 5, duration: '0:47' }, { trackNum: 6, duration: '0:43' }, { trackNum: 7, duration: '0:43' }, { trackNum: 8, duration: '1:22' },
            { trackNum: 9, duration: '0:45' }, { trackNum: 10, duration: '0:45' }, { trackNum: 11, duration: '0:45' }, { trackNum: 12, duration: '0:45' },
            { trackNum: 13, duration: '0:44' }, { trackNum: 14, duration: '0:44' }, { trackNum: 15, duration: '0:43' }, { trackNum: 16, duration: '0:42' },
            { trackNum: 17, duration: '1:56' }, { trackNum: 18, duration: '3:45' }, { trackNum: 19, duration: '2:41' }, { trackNum: 20, duration: '3:47' },
            { trackNum: 22, duration: '4:28' },
            { trackNum: 24, duration: '0:50' }, { trackNum: 25, duration: '3:45' }, { trackNum: 26, duration: '3:54' },
            { trackNum: 28, duration: '1:40' },
        ],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'I часть:', indentLevel: 1 },
            { type: 'track', section: 'Главная партия', trackNum: 2, duration: '2:17', indentLevel: 2 },
            { type: 'track', section: 'Побочная партия', trackNum: 3, duration: '2:59', indentLevel: 2 },
            { type: 'track', section: 'Заключительная партия', trackNum: 4, duration: '1:48', indentLevel: 2 },
            { type: 'subheading', section: 'Эпизод нашествия:', indentLevel: 1 },
            { type: 'track', section: '1 вариация', trackNum: 5, duration: '0:47', indentLevel: 2 },
            { type: 'track', section: '2 вариация', trackNum: 6, duration: '0:43', indentLevel: 2 },
            { type: 'track', section: '3 вариация', trackNum: 7, duration: '0:43', indentLevel: 2 },
            { type: 'track', section: '4 вариация', trackNum: 8, duration: '1:22', indentLevel: 2 },
            { type: 'track', section: '5 вариация', trackNum: 9, duration: '0:45', indentLevel: 2 },
            { type: 'track', section: '6 вариация', trackNum: 10, duration: '0:45', indentLevel: 2 },
            { type: 'track', section: '7 вариация', trackNum: 11, duration: '0:45', indentLevel: 2 },
            { type: 'track', section: '8 вариация', trackNum: 12, duration: '0:45', indentLevel: 2 },
            { type: 'track', section: '9 вариация', trackNum: 13, duration: '0:44', indentLevel: 2 },
            { type: 'track', section: '10 вариация', trackNum: 14, duration: '0:44', indentLevel: 2 },
            { type: 'track', section: '11 вариация', trackNum: 15, duration: '0:43', indentLevel: 2 },
            { type: 'track', section: '12 вариация', trackNum: 16, duration: '0:42', indentLevel: 2 },
            { type: 'track', section: 'Тема сопротивления', trackNum: 17, duration: '1:56', indentLevel: 2 },
            { type: 'track', section: 'Главная партия в репризе (до минор)', trackNum: 18, duration: '3:45', indentLevel: 2 },
            { type: 'track', section: 'Побочная партия (фа-диез минор)', trackNum: 19, duration: '2:41', indentLevel: 2 },
            { type: 'track', section: 'Кода', trackNum: 20, duration: '3:47', indentLevel: 2 },
            { type: 'track', section: 'ІІ часть. Скерцо си минор', trackNum: 22, duration: '4:28', indentLevel: 1 },
            { type: 'subheading', section: 'ІІІ часть. Адажио ре-мажор:', indentLevel: 1 },
            { type: 'track', section: '1 тема', trackNum: 24, duration: '0:50', indentLevel: 2 },
            { type: 'track', section: '2 тема', trackNum: 25, duration: '3:45', indentLevel: 2 },
            { type: 'track', section: 'Тема флейты', trackNum: 26, duration: '3:54', indentLevel: 2 },
            { type: 'track', section: 'ІV часть. Финал. Кода', trackNum: 28, duration: '1:40', indentLevel: 1 },
        ],
    },
    {
        num: 34,
        authorTitle: 'Д. Д. Шостакович. Квинтет соль минор для фортепиано, 2-х скрипок, альта и виолончели',
        performer: 'М. Крауфорд и Э. Лейтен (скрипка), Р. Чейз (альт), К. ван Кампен (виолончель), Я. Браун (фортепиано)',
        tracks: [{ trackNum: 30, duration: '0:36' }, { trackNum: 31, duration: '0:48' }, { trackNum: 32, duration: '3:00' }, { trackNum: 33, duration: '10:19' }],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'І часть. Прелюдия:', indentLevel: 1 },
            { type: 'track', section: '1-я тема', trackNum: 30, duration: '0:36', indentLevel: 2 },
            { type: 'track', section: 'Тема виолончели', trackNum: 31, duration: '0:48', indentLevel: 2 },
            { type: 'track', section: 'Средняя часть', trackNum: 32, duration: '3:00', indentLevel: 2 },
            { type: 'track', section: 'ІІ часть. Фуга', trackNum: 33, duration: '10:19', indentLevel: 1 },
        ],
    },
];

const TABLE_CONTENT_7_DISK7 = [
    {
        num: 35,
        authorTitle: 'Д. Д. Шостакович. Квинтет соль минор (продолжение)',
        performer: 'М. Крауфорд и Э. Лейтен (скрипка), Р. Чейз (альт), К. ван Кампен (виолончель), Я. Браун (фортепиано)',
        tracks: [{ trackNum: 2, duration: '3:17' }, { trackNum: 4, duration: '6:40' }, { trackNum: 5, duration: '7:07' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'III часть. Скерцо си мажор', trackNum: 2, duration: '3:17', indentLevel: 1 },
            { type: 'subheading', section: 'IV и V части:', indentLevel: 1 },
            { type: 'track', section: 'Интермецо', trackNum: 4, duration: '6:40', indentLevel: 2 },
            { type: 'track', section: 'Финал', trackNum: 5, duration: '7:07', indentLevel: 2 },
        ],
    },
    {
        num: 36,
        authorTitle: 'Д. Д. Шостакович. «Казнь Степана Разина». Ст. Е. Евтушенко. Поэма для баса, смешанного хора и оркестра',
        performer: 'Гос. Орк. СССР. Дир. К. Кондрашин. Солист – В. Грамадский',
        tracks: [
            { trackNum: 7, duration: '0:50' }, { trackNum: 8, duration: '6:22' }, { trackNum: 9, duration: '7:14' },
            { trackNum: 10, duration: '4:37' }, { trackNum: 11, duration: '4:08' }, { trackNum: 12, duration: '4:40' },
        ],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Оркестровое вступление', trackNum: 7, duration: '0:50', indentLevel: 1 },
            { type: 'track', section: 'I раздел: «Как во стольной Москве белокаменной»', trackNum: 8, duration: '6:22', indentLevel: 1 },
            { type: 'subheading', section: '2 раздел:', indentLevel: 1 },
            { type: 'track', section: 'Монолог Степана Разина', trackNum: 9, duration: '7:14', indentLevel: 2 },
            { type: 'track', section: 'Въезд Разина на Красную площадь', trackNum: 10, duration: '4:37', indentLevel: 2 },
            { type: 'subheading', section: '4-й раздел. Сцена казни:', indentLevel: 1 },
            { type: 'track', section: '«Покатилась голова...»', trackNum: 11, duration: '4:08', indentLevel: 2 },
            { type: 'track', section: 'Заключение', trackNum: 12, duration: '4:40', indentLevel: 2 },
        ],
    },
    {
        num: 37,
        authorTitle: 'Г. В. Свиридов. Поэма «Памяти Сергея Есенина»',
        performer: 'Государственная академическая русская хоровая капелла им. А. А. Юрлова. Симф. орк. Ленинградской гос. филарм. Дир. Ю. Темирканов',
        tracks: [{ trackNum: 14, duration: '4:04' }, { trackNum: 16, duration: '4:25' }, { trackNum: 18, duration: '2:40' }],
        rows: [
            { type: 'title' },
            { type: 'subheading', section: 'І часть:', indentLevel: 1 },
            { type: 'track', section: '«Край ты мой заброшенный»', trackNum: 14, duration: '4:04', indentLevel: 2 },
            { type: 'subheading', section: 'V часть:', indentLevel: 1 },
            { type: 'track', section: '«Ночь под Ивана Купала»', trackNum: 16, duration: '4:25', indentLevel: 2 },
            { type: 'subheading', section: 'Х часть:', indentLevel: 1 },
            { type: 'track', section: '«Небо как колокол»', trackNum: 18, duration: '2:40', indentLevel: 2 },
        ],
    },
    {
        num: 38,
        authorTitle: 'Г.В. Свиридов. Музыкальные иллюстрации к повести Пушкина «Метель». «Романс»',
        performer: 'Большой симф. орк. Гостелерадио СССР. Дир. В. Федосеев',
        tracks: [{ trackNum: 20, duration: '5:40' }],
        rows: [{ type: 'track', section: '«Романс»', trackNum: 20, duration: '5:40', indentLevel: 0 }],
    },
];

const TABLE_CONTENT_7_DISK8 = [
    { num: 39, authorTitle: 'В. А. Гаврилин. Симфония – действо «Перезвоны» по прочтении Шукшина. № 17 «Молитва»', performer: 'Московский камерный хор. Дир. В. Минин', tracks: [{ trackNum: 2, duration: '6:56' }], rows: [{ type: 'track', section: '№ 17 «Молитва»', trackNum: 2, duration: '6:56', indentLevel: 0 }] },
    { num: 40, authorTitle: 'В. А. Гаврилин. «Русская тетрадь». № 2 «Страдальная»', performer: 'Р. Бобринева (фортепиано)', tracks: [{ trackNum: 4, duration: '3:05' }], rows: [{ type: 'track', section: '№ 2 «Страдальная»', trackNum: 4, duration: '3:05', indentLevel: 0 }] },
    { num: 41, authorTitle: 'В. А. Гаврилин. Балет «Анюта». Вальс ля минор', performer: 'Орк. Мариинского театра. Дир. Ю. Темирканов', tracks: [{ trackNum: 6, duration: '4:17' }], rows: [{ type: 'track', section: 'Вальс ля минор', trackNum: 6, duration: '4:17', indentLevel: 0 }] },
    {
        num: 42,
        authorTitle: 'Р. К. Щедрин. Концерт для оркестра «Озорные частушки»',
        performer: 'Гос. акад. симф. орк. Дир. Е. Светланов',
        tracks: [{ trackNum: 8, duration: '1:08' }, { trackNum: 9, duration: '1:43' }, { trackNum: 10, duration: '2:35' }, { trackNum: 11, duration: '1:25' }, { trackNum: 12, duration: '1:25' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Вступление', trackNum: 8, duration: '1:08', indentLevel: 1 },
            { type: 'track', section: '1 раздел: тема скрипок quazi canto', trackNum: 9, duration: '1:43', indentLevel: 1 },
            { type: 'track', section: '2 раздел', trackNum: 10, duration: '2:35', indentLevel: 1 },
            { type: 'track', section: '3 раздел', trackNum: 11, duration: '1:25', indentLevel: 1 },
            { type: 'track', section: 'канон', trackNum: 12, duration: '1:25', indentLevel: 1 },
        ],
    },
    { num: 43, authorTitle: 'Э. В. Денисов. Пьеса для фортепиано «Знаки на белом»', performer: 'А. Филлеги (фортепиано)', tracks: [{ trackNum: 14, duration: '15:32' }], rows: [{ type: 'track', section: '«Знаки на белом»', trackNum: 14, duration: '15:32', indentLevel: 0 }] },
    {
        num: 44,
        authorTitle: 'Э. В. Денисов. «Диана в осеннем ветре»',
        performer: 'И. Богуславский (альт и камерный ансамбль)',
        tracks: [{ trackNum: 16, duration: '1:14' }, { trackNum: 17, duration: '2:20' }, { trackNum: 18, duration: '2:02' }, { trackNum: 19, duration: '3:32' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'Вступление', trackNum: 16, duration: '1:14', indentLevel: 1 },
            { type: 'track', section: '1 раздел', trackNum: 17, duration: '2:20', indentLevel: 1 },
            { type: 'track', section: 'Каденция', trackNum: 18, duration: '2:02', indentLevel: 1 },
            { type: 'track', section: '2 раздел', trackNum: 19, duration: '3:32', indentLevel: 1 },
        ],
    },
    { num: 45, authorTitle: 'А. Г. Шнитке. Симфония № 1. ІІ часть. Скерцо.', performer: 'Гос. симф. орк. Мин. Культуры СССР. Дир. В. Полянский', tracks: [{ trackNum: 21, duration: '9:53' }], rows: [{ type: 'track', section: 'ІІ часть. Скерцо', trackNum: 21, duration: '9:53', indentLevel: 0 }] },
    { num: 46, authorTitle: 'А. Г. Шнитке. Хоровой концерт, ст. Григора Нарекаци. І часть, фрагмент', performer: 'Гос. симф. орк. Мин. Культуры СССР. Дир. В. Полянский', tracks: [{ trackNum: 23, duration: '4:58' }], rows: [{ type: 'track', section: 'І часть, фрагмент', trackNum: 23, duration: '4:58', indentLevel: 0 }] },
];

const TABLE_CONTENT_7_DISK9 = [
    { num: 47, authorTitle: 'С. А. Губайдулина. Vivente – non vivente (для электронного синтезатора и магнитофона)', performer: 'С. А. Губайдуллина (синтезатор)', tracks: [{ trackNum: 2, duration: '10:47' }], rows: [{ type: 'track', section: 'Vivente – non vivente', trackNum: 2, duration: '10:47', indentLevel: 0 }] },
    {
        num: 48,
        authorTitle: 'С. М. Слонимский. Три пьесы для фортепиано:',
        performer: 'Л. Тимофеева',
        tracks: [{ trackNum: 4, duration: '3:03' }, { trackNum: 6, duration: '1:08' }, { trackNum: 8, duration: '3:12' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: '«Колокола»', trackNum: 4, duration: '3:03', indentLevel: 1 },
            { type: 'track', section: '«Мультфильм с приключениями»', trackNum: 6, duration: '1:08', indentLevel: 1 },
            { type: 'track', section: '«Проходящая красотка»', trackNum: 8, duration: '3:12', indentLevel: 1 },
        ],
    },
    { num: 49, authorTitle: 'А. П. Петров. «Я шагаю по Москве», ст. Шпаликова', performer: 'Э. Хиль', tracks: [{ trackNum: 10, duration: '2:48' }], rows: [{ type: 'track', section: '«Я шагаю по Москве»', trackNum: 10, duration: '2:48', indentLevel: 0 }] },
    {
        num: 50,
        authorTitle: 'Б. И. Тищенко. Концерт для арфы с оркестром.',
        performer: 'И. Донская (арфа). Ленинградский оркестр старинной музыки. Дир. Э. Серов. 4 часть – Т. Милентьева (сопрано)',
        tracks: [{ trackNum: 12, duration: '12:05' }, { trackNum: 13, duration: '9:55' }, { trackNum: 14, duration: '6:42' }, { trackNum: 15, duration: '5:25' }, { trackNum: 16, duration: '10:48' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'I часть. Moderato', trackNum: 12, duration: '12:05', indentLevel: 1 },
            { type: 'track', section: 'II часть. Allegro con moto', trackNum: 13, duration: '9:55', indentLevel: 1 },
            { type: 'track', section: 'III часть. Скерцо – токката', trackNum: 14, duration: '6:42', indentLevel: 1 },
            { type: 'track', section: 'IV часть. Интермеццо', trackNum: 15, duration: '5:25', indentLevel: 1 },
            { type: 'track', section: 'V часть. Финал', trackNum: 16, duration: '10:48', indentLevel: 1 },
        ],
    },
];

const TABLE_CONTENT_7_DISK10 = [
    {
        num: 51,
        authorTitle: 'С. В. Рахманинов. Соната для фортепиано №2 (си-бемоль минор). Ор. 36:',
        performer: 'В. Ашкенази (фортепиано)',
        tracks: [{ trackNum: 2, duration: '10:25' }, { trackNum: 3, duration: '8:00' }, { trackNum: 4, duration: '7:05' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'І часть. Allegro agitato', trackNum: 2, duration: '10:25', indentLevel: 1 },
            { type: 'track', section: 'II часть. Non allegro', trackNum: 3, duration: '8:00', indentLevel: 1 },
            { type: 'track', section: 'III часть. Allegro molto', trackNum: 4, duration: '7:05', indentLevel: 1 },
        ],
    },
    {
        num: 52,
        authorTitle: 'С. С. Прокофьев. Соната для фортепиано №6, Ля мажор, ор. 82:',
        performer: 'Н. Петров (фортепиано)',
        tracks: [{ trackNum: 6, duration: '8:13' }, { trackNum: 7, duration: '4:18' }, { trackNum: 8, duration: '7:34' }, { trackNum: 9, duration: '6:00' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'І часть. Allegro moderato', trackNum: 6, duration: '8:13', indentLevel: 1 },
            { type: 'track', section: 'II часть. Allegretto', trackNum: 7, duration: '4:18', indentLevel: 1 },
            { type: 'track', section: 'III часть. Tempo di valse lentissimo', trackNum: 8, duration: '7:34', indentLevel: 1 },
            { type: 'track', section: 'IV часть. Vivace', trackNum: 9, duration: '6:00', indentLevel: 1 },
        ],
    },
    {
        num: 53,
        authorTitle: 'Д. Д. Шостакович. Соната для виолончели ре минор, ор. 40:',
        performer: 'Г. Ривиниус (виолончель), П. Ривиниус (фортепиано)',
        tracks: [{ trackNum: 11, duration: '8:49' }, { trackNum: 12, duration: '3:05' }, { trackNum: 13, duration: '7:58' }, { trackNum: 14, duration: '4:10' }],
        rows: [
            { type: 'title' },
            { type: 'track', section: 'І часть. Allegro non troppo', trackNum: 11, duration: '8:49', indentLevel: 1 },
            { type: 'track', section: 'II часть. Allegro', trackNum: 12, duration: '3:05', indentLevel: 1 },
            { type: 'track', section: 'III часть. Largo', trackNum: 13, duration: '7:58', indentLevel: 1 },
            { type: 'track', section: 'IV часть. Allegro', trackNum: 14, duration: '4:10', indentLevel: 1 },
        ],
    },
];

const TABLE_CONTENT_7 = {
    1: TABLE_CONTENT_7_DISK1,
    2: TABLE_CONTENT_7_DISK2,
    3: TABLE_CONTENT_7_DISK3,
    4: TABLE_CONTENT_7_DISK4,
    5: TABLE_CONTENT_7_DISK5,
    6: TABLE_CONTENT_7_DISK6,
    7: TABLE_CONTENT_7_DISK7,
    8: TABLE_CONTENT_7_DISK8,
    9: TABLE_CONTENT_7_DISK9,
    10: TABLE_CONTENT_7_DISK10,
};

export { TABLE_CONTENT_7 };
